import { render, staticRenderFns } from "./ProjectSpecifications.vue?vue&type=template&id=a496ed16&"
import script from "./ProjectSpecifications.vue?vue&type=script&lang=js&"
export * from "./ProjectSpecifications.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSpecifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports